// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__H0pdq","btn":"styles_btn__2o88L","tags":"styles_tags__eTMex"};